var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"artical_container"}},[_c('div',{staticClass:"nav-header"},[_c('van-nav-bar',{attrs:{"title":_vm.infoObj.title,"left-arrow":""},on:{"click-left":_vm.leftFn}})],1),_c('div',{staticClass:"list"},[_c('artical-list',{attrs:{"articalObj":_vm.infoObj}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }